// extracted by mini-css-extract-plugin
module.exports = {"description":"LegalPage_description__OqGUQ","inner":"LegalPage_inner__g7j_Y","contentsTableWrap":"LegalPage_contentsTableWrap__Ira3w"};